import client from '@/services/client'
import type {
  CriterionValueFormValues,
  ICriterionValueCreatePayload,
  IFlowCriterionValue,
} from '@/types/CriteriaTypes'

import type { AxiosResponse } from 'axios'

const getAll = async (
  criterionUuid: string
): Promise<AxiosResponse<IFlowCriterionValue[]>> => {
  return await client.get<IFlowCriterionValue[]>(
    `flows/criteria/${criterionUuid}/values`
  )
}

const get = async (
  valueUuid: string
): Promise<AxiosResponse<IFlowCriterionValue>> => {
  return await client.get<IFlowCriterionValue>(
    `flows/criterion-values/${valueUuid}`
  )
}

const create = async (
  value: ICriterionValueCreatePayload
): Promise<AxiosResponse<IFlowCriterionValue>> => {
  return await client.post<IFlowCriterionValue>(`flows/criterion-values`, value)
}

const update = async (
  valueUuid: string,
  value: CriterionValueFormValues
): Promise<AxiosResponse<IFlowCriterionValue>> => {
  return await client.patch<IFlowCriterionValue>(
    `flows/criterion-values/${valueUuid}`,
    value
  )
}

/**
 * Update indexes of criterion values, order of uuids matters.
 * All values of the criterion must be provided.
 * @param {string} criterionUuid
 * @param {Array<string>} valueUuids
 */
const updateIndexes = async (
  criterionUuid: string,
  valueUuids: string[]
): Promise<AxiosResponse<IFlowCriterionValue[]>> => {
  return await client.put<IFlowCriterionValue[]>(
    `flows/criteria/${criterionUuid}/value-indexes`,
    { valueUuids }
  )
}

// Soft-deletes the value, published flows using it get archived
const destroy = async (valueUuid: string): Promise<AxiosResponse<void>> => {
  return await client.delete<void>(`flows/criterion-values/${valueUuid}`)
}

export const FlowCriterionValues = {
  getAll,
  get,
  create,
  update,
  updateIndexes,
  destroy,
}
